/**
 * InfoTooltip – reusable (i) icon + tooltip/modal. Use on any screen.
 */

export { InfoTooltip } from './InfoTooltip';
export type { InfoTooltipProps } from './InfoTooltip';
export {
  TOOLTIP_NARROW_BREAKPOINT,
  getTooltipPortalPosition,
} from './InfoTooltip.styles';
